/**
 * TDS · Bloque "Subir foto" dentro de pz-producto.
 *
 * El cliente elige (o arrastra) una foto, se sube al App Proxy de la app
 * (/apps/personaliza/upload) y la URL publica queda en el input oculto
 * properties[Foto original] del formulario de producto. Nada mas: ni
 * generacion, ni editor.
 *
 * Decisiones que importan:
 *   - Se sube con XMLHttpRequest y no con fetch solo por la barra de
 *     progreso: en movil con 10 MB, sin barra parece colgado.
 *   - Comprobaciones previas en el navegador (peso, formato) para no
 *     esperar a que el servidor rechace; el servidor vuelve a validar.
 *   - La foto subida se recuerda en sessionStorage por producto: si la
 *     pagina se recarga (cambio de variante con navegacion, atras) no hay
 *     que volver a subirla. Se olvida al cerrar la pestana.
 *   - Si es obligatorio, se bloquea anadir al carrito sin foto (captura,
 *     antes que el tema), igual que el bloque de dedicatoria.
 *
 * Sin console.log. Arranque resistente (load + MutationObserver + eventos
 * del editor), igual que el resto de bloques tds.
 */
(function () {
  'use strict';

  var EXTENSIONES = /\.(jpe?g|png|heic|heif)$/i;
  var TIPOS = /^image\/(jpeg|png|heic|heif)$/i;

  function iniciar(raiz) {
    if (!raiz || raiz.__tdsFoto) return;
    raiz.__tdsFoto = true;

    var zona = raiz.querySelector('[data-tds-foto-zona]');
    var input = raiz.querySelector('[data-tds-foto-input]');
    var vista = raiz.querySelector('[data-tds-foto-vista]');
    var img = raiz.querySelector('[data-tds-foto-img]');
    var nombre = raiz.querySelector('[data-tds-foto-nombre]');
    var progreso = raiz.querySelector('[data-tds-foto-progreso]');
    var barra = raiz.querySelector('[data-tds-foto-barra]');
    var estado = raiz.querySelector('[data-tds-foto-estado]');
    var alerta = raiz.querySelector('[data-tds-foto-alerta]');
    var oculto = raiz.querySelector('[data-tds-foto-url]');
    var btnCambiar = raiz.querySelector('[data-tds-foto-cambiar]');
    var btnQuitar = raiz.querySelector('[data-tds-foto-quitar]');
    if (!zona || !input || !oculto) return;

    var endpoint = raiz.getAttribute('data-endpoint') || '/apps/personaliza/upload';
    var maxBytes = (parseFloat(raiz.getAttribute('data-max-mb')) || 15) * 1024 * 1024;
    var obligatorio = raiz.getAttribute('data-obligatorio') === '1';
    var claveSesion = 'tds-foto:' + (raiz.getAttribute('data-clave') || 'producto');
    var txt = function (k) { return raiz.getAttribute('data-txt-' + k) || ''; };

    var subiendo = false;
    var xhrActual = null;

    // ---- avisos ----
    function avisar(texto) {
      if (alerta) { alerta.textContent = texto; alerta.hidden = false; }
      raiz.classList.add('is-error');
    }
    function silenciar() {
      if (alerta) alerta.hidden = true;
      raiz.classList.remove('is-error');
    }

    // ---- estado ----
    function tieneFoto() { return !oculto.disabled && !!oculto.value; }

    function ponerFoto(url, nombreArchivo) {
      oculto.value = url;
      oculto.disabled = false;
      if (img) img.src = url;
      if (nombre) nombre.textContent = nombreArchivo || '';
      if (vista) vista.hidden = false;
      zona.hidden = true;
      silenciar();
      try { sessionStorage.setItem(claveSesion, JSON.stringify({ url: url, nombre: nombreArchivo || '' })); } catch (e) {}
      raiz.dispatchEvent(new CustomEvent('tds-foto:cambio', { bubbles: true, detail: { url: url } }));
    }

    function quitarFoto() {
      oculto.value = '';
      oculto.disabled = true;
      if (img) img.removeAttribute('src');
      if (vista) vista.hidden = true;
      zona.hidden = false;
      input.value = '';
      try { sessionStorage.removeItem(claveSesion); } catch (e) {}
      raiz.dispatchEvent(new CustomEvent('tds-foto:cambio', { bubbles: true, detail: { url: '' } }));
    }

    function mostrarProgreso(pct) {
      if (!progreso) return;
      progreso.hidden = false;
      if (estado) estado.textContent = txt('subiendo');
      if (barra) barra.style.width = Math.max(4, Math.min(100, pct)) + '%';
    }
    function ocultarProgreso() {
      if (progreso) progreso.hidden = true;
      if (barra) barra.style.width = '0';
    }

    // ---- subida ----
    function archivoValido(archivo) {
      if (archivo.size > maxBytes) { avisar(txt('grande')); return false; }
      var tipoOk = TIPOS.test(archivo.type || '') || (!archivo.type && EXTENSIONES.test(archivo.name || ''));
      // Algunos navegadores no ponen MIME a los HEIC: vale la extension.
      if (!tipoOk && !EXTENSIONES.test(archivo.name || '')) { avisar(txt('formato')); return false; }
      return true;
    }

    function mensajeError(res) {
      var codigo = res && res.code;
      if (codigo === 'too_large') return txt('grande');
      if (codigo === 'too_small') return txt('pequena');
      if (codigo === 'bad_type' || codigo === 'unreadable') return txt('formato');
      return txt('fallo');
    }

    function subir(archivo) {
      silenciar();
      if (!archivoValido(archivo)) { input.value = ''; return; }
      // Si habia una foto y la nueva falla, se vuelve a la anterior.
      var previa = tieneFoto() ? { url: oculto.value, nombre: nombre ? nombre.textContent : '' } : null;
      var anterior = xhrActual;
      xhrActual = null;
      if (anterior) { try { anterior.abort(); } catch (e) {} }

      subiendo = true;
      zona.hidden = true;
      if (vista) vista.hidden = true;
      mostrarProgreso(0);

      var datos = new FormData();
      datos.append('file', archivo, archivo.name);

      var xhr = new XMLHttpRequest();
      xhrActual = xhr;
      xhr.open('POST', endpoint, true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.upload.onprogress = function (ev) {
        if (ev.lengthComputable) mostrarProgreso((ev.loaded / ev.total) * 100);
      };
      function fallo(mensaje) {
        if (previa) ponerFoto(previa.url, previa.nombre);
        else quitarFoto();
        avisar(mensaje);
      }
      xhr.onload = function () {
        if (xhr !== xhrActual) return; // subida sustituida por otra
        subiendo = false;
        xhrActual = null;
        ocultarProgreso();
        var res = null;
        try { res = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300 && res && res.success && res.url) {
          ponerFoto(res.url, archivo.name);
        } else {
          fallo(mensajeError(res));
        }
      };
      xhr.onerror = xhr.onabort = function () {
        if (xhr !== xhrActual) return; // abortada a proposito
        subiendo = false;
        xhrActual = null;
        ocultarProgreso();
        fallo(txt('fallo'));
      };
      xhr.send(datos);
    }

    // ---- entrada del usuario ----
    input.addEventListener('change', function () {
      var f = input.files && input.files[0];
      if (f) subir(f);
    });
    zona.addEventListener('click', function (ev) {
      // El click programatico sobre el input burbujea hasta aqui: ignorarlo
      // o se abriria el selector dos veces.
      if (ev.target === input) return;
      input.click();
    });
    zona.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); input.click(); }
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      zona.addEventListener(ev, function (e) { e.preventDefault(); zona.classList.add('is-arrastrando'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      zona.addEventListener(ev, function (e) { e.preventDefault(); zona.classList.remove('is-arrastrando'); });
    });
    zona.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) subir(f);
    });
    if (btnCambiar) btnCambiar.addEventListener('click', function () { input.value = ''; input.click(); });
    if (btnQuitar) btnQuitar.addEventListener('click', quitarFoto);

    /**
     * VISIBLE SOLO CON CIERTA VARIANTE.
     *
     * Hay cuadros que se venden en tres modelos —blanco, negro y "con tu
     * foto"— y pedir la foto cuando el cliente ha elegido el blanco sobra y
     * encima le bloquea la compra. Con `data-mostrar-si` el bloque aparece
     * solo al elegir ese modelo.
     *
     * Y una salvaguarda: si el producto NO tiene esa opción entre las suyas
     * —los discos redondos, que siempre llevan foto— el bloque se comporta
     * como siempre, visible. Así la misma plantilla vale para los dos y no
     * hay que mantener dos listas de productos.
     */
    var activadores = (raiz.getAttribute('data-mostrar-si') || '')
      .split(',')
      .map(function (v) { return v.trim().toLowerCase(); })
      .filter(Boolean);

    function formularioProducto() {
      return raiz.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    }

    /** Todos los valores que el cliente PODRÍA elegir en esta ficha. */
    function valoresPosibles() {
      var f = formularioProducto();
      if (!f) return [];
      var vals = [];
      Array.prototype.forEach.call(f.querySelectorAll('input[type="radio"]'), function (r) {
        vals.push((r.value || '').toLowerCase());
      });
      Array.prototype.forEach.call(f.querySelectorAll('select option'), function (o) {
        vals.push((o.value || '').toLowerCase());
        vals.push((o.textContent || '').trim().toLowerCase());
      });
      return vals;
    }

    /** Lo que hay elegido ahora mismo. */
    function valoresElegidos() {
      var f = formularioProducto();
      if (!f) return [];
      var vals = [];
      Array.prototype.forEach.call(f.querySelectorAll('input[type="radio"]:checked'), function (r) {
        vals.push((r.value || '').toLowerCase());
      });
      Array.prototype.forEach.call(f.querySelectorAll('select'), function (sel) {
        vals.push((sel.value || '').toLowerCase());
        var elegida = sel.options[sel.selectedIndex];
        if (elegida) vals.push((elegida.textContent || '').trim().toLowerCase());
      });
      return vals;
    }

    function coincide(lista) {
      return lista.some(function (v) {
        return activadores.some(function (a) { return v.indexOf(a) !== -1; });
      });
    }

    function visible() {
      if (!activadores.length) return true;
      // El producto no ofrece esa variante: el bloque es de los de siempre.
      if (!coincide(valoresPosibles())) return true;
      return coincide(valoresElegidos());
    }

    // Guardada mientras el bloque esta escondido (ver abajo).
    var fotoAparcada = null;

    function ajustarVisibilidad() {
      var mostrar = visible();
      raiz.hidden = !mostrar;

      // Escondido no manda nada al pedido: si el cliente subio una foto y
      // luego se paso al modelo blanco, esa foto no debe viajar con el
      // articulo. Se aparca el valor en lugar de solo deshabilitar el input,
      // porque quien monta el carrito (pz-prod-tarjeta) recoge todos los
      // [name^="properties["] del formulario sin mirar si estan deshabilitados.
      // Al volver a la variante con foto se devuelve: no hay que subirla otra vez.
      if (!mostrar) {
        if (oculto.value) fotoAparcada = oculto.value;
        oculto.value = '';
        oculto.disabled = true;
        if (alerta) { alerta.hidden = true; raiz.classList.remove('is-error'); }
      } else if (fotoAparcada && !oculto.value) {
        oculto.value = fotoAparcada;
        oculto.disabled = false;
        fotoAparcada = null;
      }
    }

    if (activadores.length) {
      ajustarVisibilidad();
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && (t.matches('input[type="radio"]') || t.matches('select'))) ajustarVisibilidad();
      }, true);
      // Algunos temas cambian la variante sin disparar `change` en el input.
      ['variant:change', 'variantChange', 'pz:variante', 'shopify:section:load']
        .forEach(function (ev) { document.addEventListener(ev, ajustarVisibilidad, true); });
    }

    // ---- bloqueo de anadir al carrito sin foto ----
    if (obligatorio) {
      var ATC = 'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [data-add-to-cart], .product-form__submit';
      var form = raiz.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      function falta() { return visible() && !tieneFoto(); }
      function bloquear(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        avisar(subiendo ? txt('subiendo') : txt('obligatorio'));
        try { raiz.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
        if (!subiendo) { try { zona.focus({ preventScroll: true }); } catch (err) {} }
      }
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest(ATC) && falta()) bloquear(e);
      }, true);
      if (form) form.addEventListener('submit', function (e) { if (falta()) bloquear(e); }, true);
    }

    // ---- foto recordada en esta pestana ----
    try {
      var guardada = JSON.parse(sessionStorage.getItem(claveSesion) || 'null');
      if (guardada && guardada.url) ponerFoto(guardada.url, guardada.nombre);
    } catch (e) {}
    // ponerFoto reactiva el input oculto: se vuelve a decidir si toca.
    if (activadores.length) ajustarVisibilidad();
  }

  function arrancar(ambito) {
    var nodos = (ambito || document).querySelectorAll('[data-tds-foto]');
    Array.prototype.forEach.call(nodos, iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  } else {
    arrancar(document);
  }
  window.addEventListener('load', function () { arrancar(document); });

  if ('MutationObserver' in window) {
    var vigilante = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodos = muts[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-tds-foto]')) iniciar(n);
          else if (n.querySelectorAll) arrancar(n);
        }
      }
    });
    var vigilar = function () {
      if (document.body) vigilante.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) vigilar();
    else document.addEventListener('DOMContentLoaded', vigilar);
  }

  document.addEventListener('shopify:section:load', function (ev) { arrancar(ev.target); });
})();
